import { DeviceInfo } from "../useDeviceDetection";

export const mockDeviceInfo: DeviceInfo = {
  device: "desktop",
  browser: "chrome",
  platform: "macos",
  isLandscape: true,
  viewportWidth: 1920,
  viewportHeight: 1080,
};

export const mockIsMobile = (isMobile = true) => {
  mockDeviceInfo.device = isMobile ? "mobile" : "desktop";
  // Default mobile to portrait
  mockDeviceInfo.isLandscape = !isMobile;
  mockDeviceInfo.viewportWidth = isMobile ? 375 : 1920;
  mockDeviceInfo.viewportHeight = isMobile ? 812 : 1080;
};

export const mockIsDesktop = (isDesktop = true) => {
  mockDeviceInfo.device = isDesktop ? "desktop" : "mobile";
  mockDeviceInfo.isLandscape = isDesktop;
  mockDeviceInfo.viewportWidth = isDesktop ? 1920 : 375;
  mockDeviceInfo.viewportHeight = isDesktop ? 1080 : 812;
};

export const mockIsMobilePortrait = () => {
  mockDeviceInfo.device = "mobile";
  mockDeviceInfo.isLandscape = false;
  mockDeviceInfo.viewportWidth = 375;
  mockDeviceInfo.viewportHeight = 812;
};

export const mockIsMobileLandscape = () => {
  mockDeviceInfo.device = "mobile";
  mockDeviceInfo.isLandscape = true;
  mockDeviceInfo.viewportWidth = 812;
  mockDeviceInfo.viewportHeight = 375;
};
